module.exports = __webpack_public_path__ + "img/weixinerweima.ec48bd29.jpg";